export const SCHEDULE_GET = 'scheduleGet'
export const TODAY_SCHEDULING_GET = 'todaySchedulingGet'
export const TODAY_SCHEDULING_GET_PAUSES = 'todaySchedulingGetPauses'
export const SCHEDULE_CREATE = 'scheduleCreate'
export const SCHEDULE_START_ATTENDANCE = 'scheduleStartAttendance'
export const SCHEDULE_BMS_SERVICES = 'scheduleBmsServices'
export const SCHEDULE_ADD_ITEM = 'scheduleAddItem'
export const SCHEDULE_DELETE_ITEM = 'scheduleDeleteItem'

export const PAYMENT_TYPES_GET = 'paymentTypesGet'
export const SCHEDULE_ADD_ITEM_ASSISTANT= 'scheduleAddItemAssistant'
export const SCHEDULE_FINISH_ATTENDANCE = 'scheduleCharge'
export const SCHEDULE_CANCEL = 'scheduleCancel'